module.exports = __webpack_public_path__ + "static/media/featured-2.3a5cdce6.jpg";